import React from 'react';

export default function NoRowsOverlayComponent({ message })
{
    return (
        <p className="h6 text-muted mt-3">
            <i className="fa fa-frown-o" />&nbsp;&nbsp;{message || "No data rows found matching your selection"}
        </p>
    );
}